export const TextSetting = {
  /********************************PAGE_TITLE TEXTS ***************************************/
  HOME_PAGE_TITLE:
    'Best Job Website in USA | Find Job in USA | USA Job Sites | ExpediUSA',
  HOME_PAGE_DESC:
    'Explore job search in USA with millions of jobs online at ExpediUSA. ExpediUSA is the largest job portal in united states with over super jobs. For more visit us - ',
  BLOG_LIST_PAGE_TITLE: 'Blogs',
  CATEGORY_PAGE_TITLE: 'Categories',
  CONTACT_US_PAGE_TITLE: 'Contact-Us',
  SUBSCRIPTION_PLAN_PAGE_TITLE: 'Subscription Plan',
  JOBS_LIST_PAGE_TITLE: 'Jobs',
  JOBS_MAP_PAGE_TITLE: 'Jobs Map View',
  EMPLOYER_LIST_PAGE_TITLE: 'Employers',
  EMPLOYER_DASHBOARD: 'My Account',
  MANAGE_JOB_POST: 'Manage Job Posts',
  SEARCH_FOR_JOBSEEKER: 'Jobseekers',
  POST_NEW_JOB: 'Post New Job',
  JOBSEEKER_DASHBOARD: 'My Profile',
  RESUME_WRITER_DASHBOARD: 'My Profile',
  APPLIED_JOB_LISTING_PAGE_TITLE: 'My Applied Jobs',
  NOTIFICATION_PAGE_TITLE: 'My Notification',
  SAVE_JOB_LISTING_PAGE_TITLE: 'My Saved Jobs',
  SCHEDULE_INTERVIEW_PAGE_TITLE: 'My Interview Schedule',
  JOB_ALERT_PAGE_TITLE: 'Job Alert',
  CHANGE_PASSWORD_PAGE_TITLE: 'Change Password',

  COVER_LETTER_PAGE_TITLE: 'Cover Letter',
  THANK_YOU_PAGE_TITLE: 'Thank You',
  COMMING_SOON_PAGE_TITLE: 'Comming Soon',
  RESUME_PAGE_TITLE: 'Resume Templates',
  PURCHASED_RESUME_PAGE_TITLE: 'My Resume Templates',
  MY_SERVICES: 'My Services',
  ADD_SERVICE: 'Add Service',
  CHAT_PAGE_TITLE: 'Chat',
  /********************************ERROR MESSAGE TEXTS ***************************************/
  ERROR_404: 'ERROR 404',
  ERROR_DESCRIPTION:
    'Oopss... this is embarassing, either you tried to access a non existing page, or our server has gone crazy.',
  ERROR_CLICK_HERE: '<a href="#">Click Here</a> to go back home',
  PASSWORD_NOT_MATCH_MSG: 'Passwords do not match.',
  VALID_SIZE_IMAGE_ERROR_MSG:
    'Please upload valid size image. Maximum uploaded file size',
  UPLOAD_IMAGE_ERROR_MSG: 'Please upload image.',
  INVALID_ACCESS_URL:
    'You are not allowed to perform this action.Please login first.',
  WELCOME_LOGIN: 'Welcome',
  SUCCESS_LOGIN: 'You have successfully logged in.',
  SUCCESS_LOGOUT: 'You have been logged out successfully.',
  NOT_ALLOWED: 'You are not allowed to access this page.',
  RESUME_LOGIN_ERROR: 'Please login as a jobseeker to purchase templates.',

  /**************************************** PROPERTY FIELD NAME FOR VALIDATION**************************************************** */
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  EMAIL: 'Email',
  PHONE_NUMBER: 'Phone number',
  GENDER: 'Gender',
  PASSWORD: 'Password',
  C_PASSWORD: 'Confirm password',
  EMAIL_PHONE: 'Email/Phone',
  THIS: 'This field',
  MOBILE_NUMBER: 'Mobile number',
  CONFIRM_MOBILE_NUMBER: 'Confirm mobile number',
  CONFIRM_EMAIL: 'Confirm Email ',
  NAME: 'Name',
  SUBJECT: 'Subject',
  MESSAGE: 'Message',
  PHONE: 'Phone',

  /******************************************TOOLTIP TEXTS************************************************** */
  PASSWORD_TOOLTIP_TEXT:
    'Password length should be minimum 8 characters with atleast 1 capital, 1 small and 1 special character.',

  /******************************************* BREADCRUMB ***************************************************************************/
  BREADCRUMB_HOME: 'Home',
  BREADCRUMB_FAQ: 'Faq',
  BREADCRUMB_CMS: 'Cms',
  BREADCRUMB_CONTACT_US: 'Contact Us',
  BREADCRUMB_LOGIN: 'Login',
  BREADCRUMB_MY_ACCOUNT: 'My Account',
  BREADCRUMB_EDIT_PROFILE: 'Edit Profile',
  BREADCRUMB_CHANGE_PASSWORD: 'Change Password',
  BREADCRUMB_THANK_YOU: 'Thank You',
  BREADCRUMB_COMMING_SOON: 'Comming Soon',
  BREADCRUMB_SIGNUP: 'Signup',
  BREADCRUMB_RESET_PASSWORD: 'Reset Password',
  BREADCRUMB_FORGOT_PASSWORD: 'Forgot Password',
  BREADCRUMB_SEARCH_DETAILS: 'Details',
  BREADCRUMB_SEARCH: 'Search',
  BREADCRUMB_PLAN: 'Plan',
  BREADCRUMB_ADS: 'Ads',
  CANCEL: 'Cancel',
  OK: 'Ok',
  ARE_YOU_SURE: 'Are You Sure',
  PLEASE_SELECT_LEAST_ONE_JOB: 'Please select at least one job.',
  PLEASE_SELECT_JOB_POST: 'Please select job post',
  CONFIRM_POST_JOB: 'You want to post selected jobs.',
  CONFIRM_DELETE_JOB: 'You want to delete selected jobs.',
  CONFIRM_LIVE_JOB: 'You want to Live the selected jobs.',
  CONFIRM_CHANGE_CLOSED: 'You want to close selected jobs.',
  CONFIRM_DELETE_SERVICE: 'You want to delete selected service.',
  CONFIRM_STATUS_UPDATE: 'You want to change status of selected service.',
  CONFIRM_COMPLETED_SERVICE: 'You want to mark the service completed.',
};
